import {
  getAllFiles,
  getConfigFiles,
  deleteImage,
  uploadFile,
  uploadDualImage,
  getFilesByType,
} from '../../services/UploadService';

export const useGallery = () => {
  return {
    getAllFiles,
    getConfigFiles,
    deleteFile: deleteImage,
    uploadFile,
    uploadDualImage,
    getFilesByType,
  };
};
